export default [
    {
        value: '\'AUTHORIZATION_IN_PROGRESS\''
    }, {
        value: '\'AUTHORIZATION_SKIPPED\''
    }, {
        value: '\'AUTHORIZED\''
    }, {
        value: '\'CONFIRMATION_ERROR\''
    }, {
        value: '\'CONFIRMED\''
    }, {
        value: '\'DENIED\''
    }, {
        value: '\'NEW\''
    }
];
